// ErrorAlert.tsx
import React, { useEffect } from 'react';
import { useAlert } from '../../context/alertContext';
import { MdClose } from 'react-icons/md';

const ErrorAlert: React.FC = () => {
  const { errorMessage, setErrorMessage } = useAlert();

  useEffect(() => {
    const timer = setTimeout(() => {
      setErrorMessage(null);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  if (!errorMessage) return null;

  return (
    <div className="fixed left-[50%] top-[20px] z-[1000] m-auto flex w-[80vw] max-w-md -translate-x-1/2 transform gap-4 rounded-lg bg-red-600 p-4 shadow-lg">
      <p className="text-white">{errorMessage}</p>
      <button
        onClick={() => setErrorMessage(null)}
        className="ml-auto mt-2 rounded-md bg-white px-4 py-2 text-red-600 hover:bg-red-100 focus:outline-none focus:ring-2 focus:ring-red-500"
      >
        <MdClose />
      </button>
    </div>
  );
};

export default ErrorAlert;
